import styled from "@emotion/styled";

export const PageContent = styled.div`
    display: flex;
    flex-direction: column;
`;
